
  import {defineComponent} from "vue";
  import * as _ from 'lodash';

  export default defineComponent({
    name: "top-button-component",
    data() {
      return {
        isTop: true,
        debouncedScrollEvent: () => {return}
      }
    },
    mounted() {
      this.debouncedScrollEvent = _.debounce(this.scrollEvent, 100);
      window.addEventListener('scroll', this.debouncedScrollEvent);
    },
    beforeUnmount(): void {
      window.removeEventListener('scroll', this.debouncedScrollEvent);
    },
    methods: {
      moveToTop(): void {
        window.scrollTo({top: 0});
      },
      scrollEvent(): void {
        // console.log(window.scrollY);
        this.isTop = (window.scrollY === 0);
      }
    }
  });
